import React, { useContext, useEffect, useState } from "react";
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import { BaseUrl } from "../../../contexts/baseUrl/baseUrl";
import Layout from "../../../components/sales/layout/layout";

const WalletRequestList = ({
    match,
    walletRequestList,
    walletrequestDetails = [],
}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const { baseUrl } = useContext(BaseUrl);
    const [listData, setListData] = useState();
    const role = JSON.parse(localStorage.getItem('roles'));
    const [roleId, setRoleId] = useState('');
    const [isModal, setIsModal] = useState(false);


    useEffect(() => {
        (async () => {
            role && setRoleId(role[0].pivot.role_id);
        })();
    }, [role]);

    const handleModalHide = () => {
        setIsModal(false);
        window.location.reload();
    }

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            // await requestApprovalList(1, 4)
            await walletRequestList(match?.params?.wallet_id);
            setIsLoading(false);
        })();
    }, []);

    const headers = [
        'Requested By',
        'Wallet Type',
        'Subcategory',
        'User Requested Amount',
        'Left Amount',
        'Finance Director',
        'Approved By',
        'Finance Date',
        'Status',
        'Created At',
        'Action'
    ];

    const onPageChange = async (val) => {
        setIsLoading(true);
        // await requestApprovalList(val.selected + 1, 4);
        await walletRequestList(match?.params?.id);
        setIsLoading(false);
    };

    useEffect(() => {
        if (walletrequestDetails &&
            walletrequestDetails?.data?.data !== undefined && walletrequestDetails?.data?.data.length > 0) {
            const tableData = ['id', 'created_by', 'wallet_type', 'subcategory', 'amount', 'left_redeem_amount', 'finance_approved_name', 'approved_name', 'finance_date', 'status', 'created_at'];
            const data = walletrequestDetails?.data?.data.map((element) => {
                const status = parseInt(element['status']);
                const isOld = parseInt(element['is_old']);
                const statusText = isOld === 0 ? 'Expired' :
                    status === 1 ? 'Manager Pending' :
                        status === 2 ? 'Finance Pending' :
                            status === 3 ? 'Manager Rejected' :
                                status === 4 ? 'Finance Approved' :
                                    status === 5 ? 'Finance Rejected' :
                                        'Unknown Status';

                const action = [];

                if (status === 4 && isOld != 0) {
                    action.push({ name: 'Send to wallet', link: `${baseUrl}/wallet/new-request/${element['is_old']}` });
                }

                action.push(
                    { name: 'Transaction Details', link: `${baseUrl}/request-transaction-details` },
                    { name: 'Request View', link: `${baseUrl}/wallet/approval-wallet-details` });

                return Object.assign(
                    ...tableData.map((key) => (
                        key === 'status' ? { [key]: statusText } : { [key]: element[key] }
                    )),
                    (element['status'] === 4 && isOld !== 0)
                        ? {
                            Action: [
                                { name: 'Send to wallet', link: `${baseUrl}/wallet/new-request/${element['is_old']}` },
                                { name: 'Transaction Details', link: `${baseUrl}/request-transaction-details` },
                                { name: 'Request View', link: `${baseUrl}/wallet/approval-wallet-details` }
                            ],
                        }
                        :
                        {
                            Action: [
                                { name: 'Transaction Details', link: `${baseUrl}/request-transaction-details` },
                                { name: 'Request View', link: `${baseUrl}/wallet/approval-wallet-details` }
                            ],
                        }

                );
            });

            if (data) {
                setListData(data);
            }
            setPageCount(Math.ceil(walletrequestDetails.total / walletrequestDetails.per_page));
        }
    }, [walletrequestDetails]);


    return (
        <>
            <Layout
                title={localization.requestList}
                isLoading={isLoading}
                isGoback={true}
            >
                <TableSection
                    data={listData}
                    isId={false}
                    isMngId={false}
                    headers={headers}
                    pageCount={pageCount}
                    onPageChange={onPageChange}
                    detailList={walletrequestDetails?.data?.data && walletrequestDetails?.data?.data}
                    srNo={walletrequestDetails?.from}
                />
            </Layout>
        </>
    )
}

export default WalletRequestList;
